"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../common");
const schema = {
    type: "object",
    properties: {
        visitDate: {
            type: "number",
            format: "date",
            title: "Called On",
            disableFuture: true,
        },
        clinicianAppointment: (0, common_1.makeAppointmentSchema)({
            disablePast: true,
        }),
        nextVisitType: {
            type: "string",
            title: "Next Visit Type",
            oneOf: [
                { const: "TELE_VISIT", title: "Tele Medicine Visit" },
                { const: "PHYSICAL_VISIT", title: "Physical Visit" },
            ],
        },
        notes: { type: "string", title: "Notes", maxLength: 3000 },
    },
    required: ["visitDate"],
};
exports.default = schema;
